import React from "react";

const CourseStructure = () => {
    return (
        <div className="course-structure">
            <div className="course-structure__content">
                <h2 className="title">ساختار دوره</h2>
                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <ul className="list-time">
                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۱۰
                                </span>
                                <span className="list-time__item__title">
                                    ده درس
                                </span>
                            </li>
                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۱۰
                                </span>
                                <span className="list-time__item__title">
                                    ۱۰ ماهه
                                </span>
                            </li>
                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۵
                                </span>
                                <span className="list-time__item__title">
                                    پنج ترم دوماهه
                                </span>
                            </li>
                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۲
                                </span>
                                <span className="list-time__item__title">
                                    ارائه دو درس در هر ترم
                                </span>
                            </li>

                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۳۰
                                </span>
                                <span className="list-time__item__title">
                                    ۳۰ درصد تدریس اساتید
                                </span>
                            </li>

                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۱۰
                                </span>
                                <span className="list-time__item__title">
                                    ۱۰ درصد تجربه صنعت
                                </span>
                            </li>

                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۱۵
                                </span>
                                <span className="list-time__item__title">
                                    ۱۵ درصد مورد کاوی
                                </span>
                            </li>

                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۳۵
                                </span>
                                <span className="list-time__item__title">
                                    ۳۵ درصد کلاس زنده و حضوری
                                </span>
                            </li>

                            <li className="list-time__item">
                                <span className="list-time__item__number">
                                    ۱۰
                                </span>
                                <span className="list-time__item__title">
                                    ۱۰  درصد یادگیری جمعی
                                </span>
                            </li>

                        </ul>
                    </div>
                    <div className="col-xs-12 col-sm-8">
                        <img
                            className="course-structure__image"
                            src="/images/staructure_amir.jpg"
                            alt="derayat mba road map"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CourseStructure;
